import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=6018f48e&scoped=true"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=ts"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=ts"
import style0 from "./PrivacyPolicy.vue?vue&type=style&index=0&id=6018f48e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6018f48e",
  null
  
)

export default component.exports